import { gql } from '@apollo/client'

import PROJECT_IMAGE_FRAGMENT from './components/Syllabus/components/SyllabusProjectImage/fragments'
import PROJECT_VIDEO_FRAGMENT from './components/Syllabus/components/SyllabusProjectVideo/fragments'

import COURSES_FRAGMENT from 'src/components/sections/TopCourses/fragments'
import HELP_CENTER_ARTICLES_FRAGMENT from 'src/components/sections/HelpCenterArticles/fragments'
import LIBRARY_POST_FRAGMENT from 'src/components/sections/SuperLibraryPosts/fragments'
import LIBRARY_GUIDE_FRAGMENT from 'src/components/sections/SuperLibraryGuides/fragments'

export const COURSE_ACCESS = gql`
  query Course_CourseAccess {
    session {
      id
      isAdmin
      type
      courses {
        nodes {
          id
          course {
            id
          }
        }
      }
    }
  }
`

export const PAGES = gql`
  query Course_pages {
    productCourses(perPage: 200) {
      nodes {
        id
        slug
      }
    }
  }
`

export const EXTRA = gql`
  query Course_extra($otherCoursesSubject: ProductCourseSubject!) {
    topGuides: libraryGuides(perPage: 3) {
      ...SuperLibraryGuidesComponent
    }

    topPosts: libraryPosts(perPage: 3) {
      ...SuperLibraryPostsComponent
    }

    otherCourses: productCourses(perPage: 4, subject: $otherCoursesSubject) {
      ...TopCoursesComponent
    }
  }

  ${COURSES_FRAGMENT}
  ${LIBRARY_POST_FRAGMENT}
  ${LIBRARY_GUIDE_FRAGMENT}
`

export default gql`
  query Course($slug: String!, $statuses: [ProductStatus]) {
    productCourse(slug: $slug, statuses: $statuses) {
      id
      title
      slug
      isBeta
      shortDescription
      releaseDate
      description
      subjects
      status
      image {
        url
        width
        height
        blurhash
      }
      length
      overview
      instructors {
        id
        name
        image {
          url
        }
        description
        facebook
        instagram
        twitter
      }
      faqs {
        __typename
        id
        title
        body
      }
      lowestPrice {
        currencyCode
        value
      }
      projects {
        ...SyllabusListProjectImageComponent
        ...SyllabusListProjectVideoComponent
      }
      syllabusUrl
      mailchimpTag
      difficultyLevel
      contents {
        title
        description
      }
      requirements
      targetAudience
      variants {
        nodes {
          id
        }
      }
      course {
        id
        slug
        location
      }
    }
  }

  ${PROJECT_IMAGE_FRAGMENT}
  ${PROJECT_VIDEO_FRAGMENT}
`
